<template>
    <DataTable
        dataKey="id"
        ref="dt"
        :value="tableData"
        v-model:selection="selectedProducts"

        :paginator="(tableOptions.paginator === undefined || tableOptions.paginator == true) ?( tableData && tableData.length > 0 ? true : false) : false"
        :rows="(tableOptions.paginator === undefined || tableOptions.paginator == true) ? rowsPerPage : 1"
        :rowsPerPageOptions="rowsPerPageOptions"
        :showFilterMenu="true"
        v-model:filters="filters"
        :filters="filters"
        filterDisplay="menu"
        paginatorPosition="both"
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink JumpToPageInput RowsPerPageDropdown"
        :currentPageReportTemplate="TR.table_page_info"
        responsiveLayout="scroll"
        :reorderableColumns="false"
        sortMode="single"
        :removableSort="true"
        @value-change="onChangeValue"
        @filter="onFiltered"
        :rowClass="tableRowClass"
        :stripedRows="false"
        :showGridlines="true"
        class="dt-main"
        :exportFilename="tableOptions.export_filename !== undefined ? tableOptions.export_filename : 'download'"
        :exportFunction="expF"

        :globalFilterFields="tableOptions.globalFilterFields"
        >
        <!-- selectionMode="single1" -->
        <!-- :resizableColumns="true"
        columnResizeMode="expand" -->
        <!-- scrollHeight="flex"
        :contentStyle="{ height: '200px' }"
        scrollable -->

        <!-- editMode="row"
        v-model:editingRows="editingRows"-->

        <!-- stateStorage="session" stateKey="dt-state-demo-session" -->
        <!-- currentPageReportTemplate="Showing {first} to {last} of {totalRecords} tableData" -->
        <!-- @columnReorder="onColReorder"
        @rowReorder="onRowReorder"-->
        <template #empty>
            <div class="d-flex justify-content-sm-center">{{TR.emptyFilterMessage}}</div>
        </template>
        <template #loading><i class='fas fa-spinner fa-spin me-2'></i> {{ TR.loading }}</template>

        <template #header>
            <div class="table-header d-flex flex-column flex-sm-row justify-content-start">
                <MultiSelect
                    v-if="tableOptions.paginator !== undefined && tableOptions.paginator == false"
                    v-model="selectedColumns"
                    :options="table_columns"
                    optionValue="value"
                    optionLabel="label"
                    :maxSelectedLabels="0"
                    display="chip"
                    class="border-0 float-start1 p-2"
                    :title="TR.select_columns"
                >
                    <!-- placeholder=""
                    selectedItemsLabel="" -->
                    <!-- :selectedItemsLabel="`{0} ${TR.category?.toLowerCase()} ${TR.selected?.toLowerCase()}`" -->
                    <template #option="slotProps">
                        <div class="d-flex align-items-center" style="width: 180px;">
                            <div
                                v-html="(slotProps.option.icon ? `${slotProps.option.icon} ` : '' ) + slotProps.option.label"
                            ></div>
                        </div>
                    </template>
                    <template #dropdownicon>
                        <i class="fas fa-list" />
                    </template>
                </MultiSelect>

                <button
                    v-if="tableOptions.filterClearBtn === undefined || tableOptions.filterClearBtn == true"
                    type="button"
                    :title="TR.clear"
                    class="mb-2 mb-sm-0 me-4 btn btn-outline-danger"
                    @click="clearFilter()"
                >
                    <i class="fas fa-filter"></i>
                    {{ TR.clear_filter }}
                </button>

                <template v-if="tableOptions.header_buttons && tableOptions.header_buttons.length">
                    <template v-for="(btn, bi) in tableOptions.header_buttons" :key="bi">
                        <!-- v-if="btn.private === undefined || !btn.private" -->
                        <button
                            v-if="btn.private === undefined || (typeof btn.private === 'function' ? (btn.private(btn) === false ? true : false) : (btn.private === false ? true : false))"
                            :title="btn.title !== undefined ? btn.title : ''"
                            :class="`mb-2 mb-sm-0 me-sm-4 me-1 btn ${btn.class}`"
                            @click="typeof btn.eventCallback === 'function' ? btn.eventCallback($event) : null"
                        >
                            <i :class="btn.icon"></i>
                            {{btn.label}}
                        </button>
                    </template>
                </template>

                <div class="ms-sm-auto">
                    <button
                        v-if="tableOptions !== undefined && (tableOptions.export_button !== undefined && tableOptions.export_button == true)"
                        type="button"
                        :title="TR.download"
                        class="mb-2 mb-sm-0 me-1 btn btn-outline-primary"
                        @click="exportCSV()"
                    >
                        <i class="fas fa-download"></i>
                        {{TR.download}}
                    </button>

                    <!-- <div class="p-input-icon-left">
                        <i class="pi pi-search" />
                        <i v-if="filterClear" class="pi pi-times clear-text-btn" @click="clearFilterText"></i>
                        <template v-if="filters && filters['global']">
                            <InputText v-model="filters['global'].value" :placeholder="TR.search" @keydown="filterTextChange" />
                        </template>
                    </div> -->
                    <template v-if="filters && filters['global']">
                        <InputClear v-model="filters['global'].value" icon="fas fa-search" :placeholder="TR.search" />
                    </template>
                </div>
            </div>
        </template>

        <template #paginatorstart>
            <!-- <button type="button" class="btn"><i class="fas fa-sync ms-3 text-info"></i></button> -->
            <MultiSelect
                v-if="tableOptions.paginator === undefined || tableOptions.paginator == true"
                v-model="selectedColumns"
                :options="table_columns"
                optionValue="value"
                optionLabel="label"
                :maxSelectedLabels="0"
                display="chip"
                class="border-0 float-start1 p-2"
                :title="TR.select_columns"
            >
                <!-- placeholder=""
                selectedItemsLabel="" -->
                <!-- :selectedItemsLabel="`{0} ${TR.category?.toLowerCase()} ${TR.selected?.toLowerCase()}`" -->
                <template #option="slotProps">
                    <div class="d-flex align-items-center" style="width: 180px;">
                        <div
                            v-html="(slotProps.option.icon ? `${slotProps.option.icon} ` : '' ) + slotProps.option.label"
                        ></div>
                    </div>
                </template>
                <template #dropdownicon>
                    <i class="fas fa-list" />
                </template>
            </MultiSelect>
        </template>
        <template #paginatorend>
            <!-- <button type="button" class="btn"><i class="fas fa-download me-3"></i></button> -->
        </template>

        <Column
            v-if="tableOptions.row_multiple_select !== undefined && tableOptions.row_multiple_select"
            selectionMode="multiple"
            style="width: 3rem;"
            class="text-center"
            :exportable="false"
            :reorderableColumn="false"
        ></Column>

        <Column
            :exportable="false"
            :sortable="false"
            :reorderableColumn="false"
            style="width: 4rem;"
            class="text-center"
            :header="TR.rank"
        >
            <template #body="{index}">{{dt !== null && dt != undefined && dt.d_first !== undefined ? dt.d_first+index+1 : (index + 1)}}</template>
        </Column>

        <Column
            v-if="tableOptions.row_buttons !== undefined && tableOptions.row_buttons.filter((e) => e.private === undefined || e.private !== '').length"
            :exportable="false"
            :reorderableColumn="false"
            :header="TR.operation"
            style="width: 10rem;"
            headerClass="text-center"
            bodyClass="text-center d-inline-flex1 d-block1 justify-content-center align-items-center btnicon"
        >
            <template #body="{data}">
                <template v-for="(item, index) in tableOptions.row_buttons" :key="index">
                    <button
                        v-if="item.element == undefined && (item.private === undefined || (typeof item.private === 'function' ? (item.private(data) === false ? true : false) : (item.private === false ? true : false)))"
                        :class="`me-sm-21 rounded-circle btn ${item.class}`"
                        :title="item.title !== undefined ? item.title : ''"
                        @click="typeof item.eventCallback === 'function' ? item.eventCallback(data, $event) : null"
                    >
                        <i :class="`pt-13 ${item.icon}`"></i>
                        {{item.label}}
                    </button>

                    <router-link
                        v-else-if="item.element == 'router' && (item.private === undefined || (typeof item.private === 'function' ? (item.private(data) === false ? true : false) : (item.private === false ? true : false)))"
                        :class="`me-sm-21 rounded-circle btn ${item.class}`"
                        :title="item.title !== undefined ? item.title : ''"
                        @click="typeof item.eventCallback === 'function' ? item.eventCallback(data, $event) : null"
                        :target="item.target || '_blank'"
                        :to="item.to !== undefined && typeof item.to === 'function' ? item.to(data) : item.to"
                    >
                        <i :class="`pt-13 ${item.icon}`"></i>
                        {{item.label}}
                    </router-link>

                    <div v-else-if="item.element == 'switch' && (item.private === undefined || (typeof item.private === 'function' ? (item.private(data) === false ? true : false) : (item.private === false ? true : false)))" class="form-switch d-inline-block mb-0 ms-2" :class="item.elementClass" :title="item.title !== undefined ? item.title : ''">
                        <div class="form-check form-switch d-inline-block mb-0" :class="item.elementClass" :title="item.title !== undefined ? item.title : ''">
                            <input class="form-check-input mt-2" :[item.attr]="item.attrValue" :checked="typeof item.value !== 'function' ? data[item.name] : item.value(data)" @[item.eventName]="typeof item.eventCallback === 'function' ? item.eventCallback(data, $event) : null" type="checkbox" role="switch" :disabled="typeof item.disabled !== 'undefined' ? (typeof item.disabled !== 'function' ? data[item.name] : item.disabled(data)) : false" />
                        </div>
                    </div>

                    <div v-else-if="item.element == 'checkbox' && (item.private === undefined || (typeof item.private === 'function' ? (item.private(data) === false ? true : false) : (item.private === false ? true : false)))" class="form-check d-inline-block mb-0 ms-2" :class="item.elementClass" :title="item.title !== undefined ? item.title : ''">
                        <div class="form-check ms-3 mb-0" :class="item.elementClass" :title="item.title !== undefined ? item.title : ''">
                            <input :id="'checkbox_' + index" class="form-check-input" :class="item.elementClass" :checked="typeof item.value !== 'function' ? data[item.name] : item.value(data)" @[item.eventName]="typeof item.eventCallback === 'function' ? item.eventCallback(data, $event) : null" type="checkbox" role="switch" :disabled="typeof item.disabled !== 'undefined' ? (typeof item.disabled !== 'function' ? data[item.name] : item.disabled(data)) : false" />
                            <label :for="'checkbox_' + index" class="small text-muted ms-1" v-if="item.checkbox_label !== undefined" v-html="typeof item.checkbox_label !== 'function' ? item.checkbox_label : item.checkbox_label(data)"></label>
                        </div>
                    </div>

                </template>
            </template>
        </Column>

        <template v-if="tableOptions">
            <template v-for="(item, tcindex) in tableOptions.data_table_columns.filter(t => selectedColumns?.includes(t.name))" :key="tcindex">
                <Column
                    v-if="selectedColumns.length && selectedColumns?.includes(item.name) && item.private_column === undefined ? true : ( item.private_column && item.private_column == true ? false : true)"
                    :key="tcindex"
                    :field="item.name"
                    :showFilterMatchModes="item.showFilterMatchModes === undefined || item.showFilterMatchModes ? true : false"
                    :header="item.title || item.name"
                    :exportable="item.exportable === undefined || item.exportable ? true : false"
                    :sortable="item.sortable === undefined || item.sortable ? true : false"
                    :dataType="item.data_type !== undefined && item.data_type ? item.data_type : 'text'"
                    :filterMenuStyle="{'width':'16rem'}"
                    :filterField="(item.filter === undefined || item.filter) && item.filter_field ? item.filter_field : item.name"
                    :maxConstraints="G.columnMaxConstraints"
                    :style="item.style || ''"
                    :class="item.class || ''"
                    :headerStyle="item.header_style || ''"
                    :headerClass="item.header_class || ''"
                    :bodyStyle="item.body_style || ''"
                    :bodyClass="item.body_class || ''"
                >
                    <template #body="{data}">
                        <template v-if="item.element === undefined">
                            <!--
                                <div v-if="item.filter_mode !== undefined && (item.filter_mode == 'date' || item.filter_mode == 'time' || item.filter_mode == 'datetime')" :class="item.class || ''">{{ data[item.name] && data[item.name] != '' && data[item.name] != null ? moment.utc(typeof item.value !== 'function' ? ( data[item.name]?.split("+")[1].length > 5 ? data[item.name].slice(0, -3) : data[item.name] ) : item.value(data)).tz(G.systemData?.timezone?.value).format(G.datetime_format[item.filter_mode]) : null }}</div>
                                -->
                            <div v-if="item.filter_mode !== undefined && (item.filter_mode == 'date' || item.filter_mode == 'time' || item.filter_mode == 'datetime')" :class="item.class || ''">{{ data[item.name] && data[item.name] != '' && data[item.name] != null ? ( typeof item.value !== 'function' ? G.dateToStr(data[item.name], item.filter_mode) : item.value(data) ) : '' }}</div>

                            <div v-else-if="item.filter_mode !== undefined && item.filter_mode == 'currency'" :class="item.class || ''">{{ G.formatLocale(typeof item.value !== 'function' ? data[item.name] : item.value(data)) }}</div>
                            <div v-else v-html="typeof item.value !== 'function' ? data[item.name] : item.value(data)" :class="item.class || ''"></div>
                        </template>

                        <div v-else-if="item.element == 'switch'" class="d-flex justify-content-center">
                            <div class="form-check form-switch" :class="item.elementClass">
                                <input class="form-check-input" :[item.attr]="item.attrValue" :checked="typeof item.value !== 'function' ? data[item.name] : item.value(data)" @[item.eventName]="typeof item.eventCallback === 'function' ? item.eventCallback(data, $event) : null" type="checkbox" role="switch" :disabled="typeof item.disabled !== 'undefined' ? (typeof item.disabled !== 'function' ? data[item.name] : item.disabled(data)) : false" />
                            </div>
                        </div>

                        <div v-else-if="item.element == 'checkbox'">
                            <input :id="'checkbox_' + index" class="form-check-input" :class="item.elementClass" :checked="typeof item.value !== 'function' ? data[item.name] : item.value(data)" @[item.eventName]="typeof item.eventCallback === 'function' ? item.eventCallback(data, $event): null" type="checkbox" role="switch" :disabled="typeof item.disabled !== 'undefined' ? (typeof item.disabled !== 'function' ? data[item.name] : item.disabled(data)) : false" />
                            <label :for="'checkbox_' + index" class="small text-muted ms-1" v-if="item.checkbox_label !== undefined" v-html="typeof item.checkbox_label !== 'function' ? item.checkbox_label : item.checkbox_label(data)"></label>
                        </div>

                        <input v-else-if="item.element == 'text'" class="form-control" :class="item.elementClass" :value="typeof item.value !== 'function' ? data[item.name] : item.value(data)" @[item.eventName]="typeof item.eventCallback === 'function' ? item.eventCallback(data, $event) : null" type="text" :disabled="typeof item.disabled !== 'undefined' ? (typeof item.disabled !== 'function' ? data[item.name] : item.disabled(data)) : false" />

                        <button v-else-if="item.element == 'button'" :class="item.elementClass" @[item.eventName]="typeof item.eventCallback === 'function' ? item.eventCallback(data, $event) : null" :disabled="typeof item.disabled !== 'undefined' ? (typeof item.disabled !== 'function' ? data[item.name] : item.disabled(data)) : false">
                            <i v-if="item.icon" :class="item.icon"></i>
                            <span>{{item.text}}</span>
                        </button>

                        <div v-else v-html="typeof item.value !== 'function' ? data[item.name] : item.value(data)" :class="item.class || ''"></div>
                    </template>

                    <template
                        v-if="item.filter === undefined || item.filter ? true : false"
                        #filter="{filterModel}"
                    >
                        <InputText
                            v-if="item.filter_mode === undefined || item.filter_mode == 'text'"
                            type="text"
                            v-model="filterModel[item.filter_model !== undefined && item.filter_model == 'label' ? 'label' : 'value']"
                            class="p-column-filter"
                            :placeholder="item.placeholder || item.title || ''"
                        />

                        <InputNumber
                            v-else-if="item.filter_mode == 'numeric'"
                            v-model="filterModel[item.filter_model !== undefined && item.filter_model == 'label' ? 'label' : 'value']"
                            :useGrouping="item.grouping === undefined || item.grouping == true ? true : false"
                            :placeholder="item.placeholder || item.title || ''"
                        />

                        <InputNumber
                            v-else-if="item.filter_mode == 'currency'"
                            v-model="filterModel[item.filter_model !== undefined && item.filter_model == 'label' ? 'label' : 'value']"
                            :useGrouping="item.grouping === undefined || item.grouping == true ? true : false"
                            mode="currency"
                            :currency="store.getCurrency()"
                            :locale="`${store.getLang()}-${store.getLang().toUpperCase()}`"
                            :placeholder="item.placeholder || item.title || ''"
                        />

                        <InputNumber
                            v-else-if="item.filter_mode == 'integer'"
                            v-model="filterModel[item.filter_model !== undefined && item.filter_model == 'label' ? 'label' : 'value']"
                            :useGrouping="item.grouping === undefined || item.grouping == true ? true : false"
                            integeronly
                        />

                        <InputMask
                            v-else-if="item.filter_mode == 'mask'"
                            v-model="filterModel[item.filter_model !== undefined && item.filter_model == 'label' ? 'label' : 'value']"
                            :mask="item.input_mask !== undefined && item.input_mask != '' ? item.input_mask : '9'"
                            :placeholder="item.input_mask !== undefined && item.input_mask != '' ? item.input_mask : '9'"
                        />

                        <!-- DatePicker
                            v-else-if="item.filter_mode == 'date' || item.filter_mode == 'datetime'"
                            v-model="filterModel[item.filter_model !== undefined && item.filter_model == 'label' ? 'label' : 'value']"
                            :dateFormat="item.filter_format"
                            :showTime="item.showTime === undefined ? true : item.showTime"
                            :showSeconds="item.showSeconds === undefined ? true : item.showSeconds"
                            :showButtonBar="true"
                            :hideOnDateTimeSelect="true"
                            :placeholder="item.placeholder || item.title || 'dd.mm.yyyy'"
                            showIcon fluid iconDisplay="input"
                        >
                            <template #inputicon="slotProps">
                                <i class="far fa-calendar-alt" @click="slotProps.clickCallback" />
                            </template>
                        </DatePicker -->

                        <DatePicker
                            v-else-if="item.filter_mode == 'date' || item.filter_mode == 'datetime'"
                            v-model="filterModel[item.filter_model !== undefined && item.filter_model == 'label' ? 'label' : 'value']"
                            :dateFormat="item.filter_format"
                            :showTime="item.showTime === undefined ? true : item.showTime"
                            :showSeconds="item.showSeconds === undefined ? true : item.showSeconds"
                            :stepMinute="item.stepMinute === undefined ? 1 : item.stepMinute"
                            :timeOnly="item.filter_mode == 'datetime' ? false : (item.timeOnly !== undefined ? item.timeOnly : false)"
                            :hourFormat="item.hourFormat || '24'"
                            :hideOnDateTimeSelect="true"
                            :showButtonBar="true"
                            :placeholder="item.placeholder || item.title || 'dd.mm.yyyy'"
                            :view="item.view_mode ? item.view_mode : 'date'"
                            :maxDate="item.maxDate || null"
                            :minDate="item.minDate || null"
                            showIcon fluid iconDisplay="input"
                        >
                            <template #inputicon="slotProps">
                                <i class="far fa-calendar-alt" @click="slotProps.clickCallback" />
                            </template>
                        </DatePicker>

                        <DatePicker
                            v-else-if="item.filter_mode == 'time'"
                            v-model="filterModel[item.filter_model !== undefined && item.filter_model == 'label' ? 'label' : 'value']"
                            :dateFormat="item.filter_format"
                            :showTime="item.showTime === undefined ? true : item.showTime"
                            :showSeconds="item.showSeconds === undefined ? true : item.showSeconds"
                            :timeOnly="true"
                            :hourFormat="item.hourFormat || '24'"
                            :hideOnDateTimeSelect="true"
                            :showButtonBar="true"
                            :placeholder="item.placeholder || item.title || 'dd.mm.yyyy'"
                            showIcon fluid iconDisplay="input"
                        >
                            <template #inputicon="slotProps">
                                <i class="far fa-clock" @click="slotProps.clickCallback" />
                            </template>
                        </DatePicker>

                        <Select
                            v-else-if="item.filter_mode == 'dropdown'"
                            v-model="filterModel[item.filter_model !== undefined && item.filter_model == 'label' ? 'label' : 'value']"
                            :options="item.dropdown_items"
                            optionValue="value"
                            optionLabel="label"
                            :placeholder="item.placeholder || TR.select"
                            class="p-column-filter"
                            :showClear="true"
                        >
                            <template #value="slotProps">
                                <div
                                    :class="item.dropdown_item_class !== undefined && typeof item.dropdown_item_class === 'function' ? item.dropdown_item_class(slotProps.value) : item.dropdown_item_class"
                                    v-if="slotProps.value"
                                >{{item.dropdown_items.filter((e) => e.value == slotProps.value)[0].label}}</div>
                                <span v-else>{{slotProps.placeholder}}</span>
                            </template>
                            <template #option="slotProps">
                                <div
                                    :class="item.dropdown_item_class !== undefined && typeof item.dropdown_item_class === 'function' ? item.dropdown_item_class(slotProps.option.value) : item.dropdown_item_class"
                                >{{slotProps.option.label}}</div>
                            </template>
                        </Select>

                        <MultiSelect
                            v-else-if="item.filter_mode == 'multidropdown'"
                            v-model="filterModel[item.filter_model !== undefined && item.filter_model == 'label' ? 'label' : 'value']"
                            :options="item.dropdown_items"
                            :filter="item.dropdown_items.length > 10 ? true : false"
                            optionValue="value"
                            optionLabel="label"
                            :placeholder="TR.select"
                            :showClear="true"
                            display="chip"
                            :maxSelectedLabels="2"
                            :selectedItemsLabel="`{0} ${TR.data_category?.toLowerCase()} ${TR.selected?.toLowerCase()}`"
                        >
                            <!--
                                <template #option="slotProps">
                                    <div
                                        :class="item.dropdown_item_class !== undefined && typeof item.dropdown_item_class === 'function' ? item.dropdown_item_class(slotProps.option.value) : item.dropdown_item_class"
                                        v-html="slotProps.option.label"
                                    ></div>
                                </template>
                            -->
                            <template #option="slotProps">
                                <div class="d-flex align-items-center" style="width: 180px;">
                                    <div
                                    :class="item.dropdown_item_class !== undefined && typeof item.dropdown_item_class === 'function' ? item.dropdown_item_class(slotProps.option.value) : item.dropdown_item_class"
                                    v-html="(slotProps.option.icon ? `${slotProps.option.icon} ` : '' ) + slotProps.option.label"
                                    ></div>
                                </div>
                            </template>
                            <template #dropdownicon>
                                <i class="fas fa-list" />
                            </template>
                        </MultiSelect>
                    </template>

                    <template
                        v-if="item.filter === undefined || item.filter ? true : false"
                        #filterclear="{filterCallback}"
                    >
                        <Button
                            type="button"
                            icon="fas fa-times"
                            @click="filterCallback();resetFilter(item.filter_field ? item.filter_field : item.name)"
                            class="p-button-outlined p-button-primary"
                        ></Button>
                    </template>
                    <template
                        v-if="item.filter === undefined || item.filter ? true : false"
                        #filterapply="{filterCallback}"
                    >
                        <Button
                            type="button"
                            icon="fas fa-check"
                            @click="filterCallback()"
                            class="p-button-primary"
                        ></Button>
                    </template>
                </Column>
            </template>
        </template>

        <ColumnGroup type="footer" :reorderableColumn="false" v-if="tableOptions.row_total !== undefined && tableOptions.row_total == true && tableOptions.data_table_columns !== undefined">
            <Row>
                <Column
                    :footer="TR.total"
                    :colspan="(tableOptions.row_multiple_select !== undefined && tableOptions.row_multiple_select ? 1 : 0) + 1 + (tableOptions.row_buttons !== undefined && tableOptions.row_buttons.filter((e)=>e.private === undefined || !e.private).length ? 1 : 0)"
                    :reorderableColumn="false"
                    footerStyle="text-align:right"
                />
                <Column v-for="(item, cgindex) in tableOptions.data_table_columns" :key="cgindex" :class="item.class">
                    <template #footer>
                        <template v-if="typeof tableOptions.row_total_field !== undefined && tableOptions.row_total_field.length ? tableOptions.row_total_field.filter((e) => e === item.name) : false">{{ pageTotal[item.name] }}</template>
                    </template>
                </Column>
            </Row>
            <!-- <Row v-if="tableData.length > rowsPerPage">
                <Column
                    :footer="TR.total_by_filter"
                    :colspan="(tableOptions.row_multiple_select !== undefined && tableOptions.row_multiple_select ? 1 : 0) + 1 + (tableOptions.row_buttons !== undefined && tableOptions.row_buttons.filter((e)=>e.private === undefined || !e.private).length ? 1 : 0)"
                    footerStyle="text-align:right"
                    :reorderableColumn="false"
                />
                <Column v-for="(item, cgindex) in tableOptions.data_table_columns" :key="cgindex" :reorderableColumn="false" :class="item.class">
                    <template #footer>
                        <template v-if="typeof tableOptions.row_total_field !== undefined && tableOptions.row_total_field.length ? tableOptions.row_total_field.filter((e) => e === item.name) : false">{{ filteredTotal[item.name] }}</template>
                    </template>
                </Column>
            </Row> -->
            <Row v-if="tableData.length > rowsPerPage">
                <Column
                    :footer="TR.final"
                    :colspan="(tableOptions.row_multiple_select !== undefined && tableOptions.row_multiple_select ? 1 : 0) + 1 + (tableOptions.row_buttons !== undefined && tableOptions.row_buttons.filter((e)=>e.private === undefined || !e.private).length ? 1 : 0)"
                    footerStyle="text-align:right"
                    :reorderableColumn="false"
                />
                <Column v-for="(item, cgindex) in tableOptions.data_table_columns" :key="cgindex" :reorderableColumn="false" :class="item.class">
                    <template #footer>
                        <template v-if="typeof tableOptions.row_total_field !== undefined && tableOptions.row_total_field.length ? tableOptions.row_total_field.filter((e) => e === item.name) : false">{{ allTotal[item.name] }}</template>
                    </template>
                </Column>
            </Row>
        </ColumnGroup>


        <!-- <ColumnGroup type="footer" :reorderableColumn="false" v-if="tableOptions.row_total && tableOptions.data_table_columns">
            <Row>
                <Column
                    :footer="TR.total"
                    :colspan="(tableOptions.row_multiple_select !== undefined && tableOptions.row_multiple_select ? 1 : 0) + 1 + (tableOptions.row_buttons !== undefined && tableOptions.row_buttons.filter((e)=>e.private === undefined || !e.private).length ? 1 : 0)"
                    footerStyle="text-align:right"
                    :reorderableColumn="false"
                />
                <Column v-for="(item, index) in tableOptions.data_table_columns" :key="index" :reorderableColumn="false"
                    :class="item.class || ''">
                    <template>
                        <template v-if="typeof tableOptions.row_total_field !== undefined && tableOptions.row_total_field.length ? tableOptions.row_total_field.filter((e) => e === item.name) : false">{{ pageTotal[item.name] }}</template>
                        <template v-else></template>
                    </template>
                </Column>
            </Row>
            <Row v-if="tableData.length > tableOptions.rows">
                <Column
                    :footer="TR.total_by_filter"
                    :colspan="(tableOptions.row_multiple_select !== undefined && tableOptions.row_multiple_select ? 1 : 0) + 1 + (tableOptions.row_buttons !== undefined && tableOptions.row_buttons.filter((e)=>e.private === undefined || !e.private).length ? 1 : 0)"
                    footerStyle="text-align:right"
                    :reorderableColumn="false"
                />
                <Column v-for="(item, index) in tableOptions.data_table_columns" :key="index" :reorderableColumn="false"
                    :class="item.class || ''">
                    <template>
                        <template v-if="typeof tableOptions.row_total_field !== undefined && tableOptions.row_total_field.length ? tableOptions.row_total_field.filter((e) => e === item.name) : false">{{ filteredTotal[item.name] }}</template>
                        <template v-else ></template>
                    </template>
                </Column>
            </Row>
            <Row v-if="tableData.length > tableOptions.rows">
                <Column
                    :footer="TR.final"
                    :colspan="(tableOptions.row_multiple_select !== undefined && tableOptions.row_multiple_select ? 1 : 0) + 1 + (tableOptions.row_buttons !== undefined && tableOptions.row_buttons.filter((e)=>e.private === undefined || !e.private).length ? 1 : 0)"
                    footerStyle="text-align:right"
                    :reorderableColumn="false"
                />
                <Column v-for="(item, index) in tableOptions.data_table_columns" :key="index" :reorderableColumn="false"
                    :class="item.class || ''">
                    <template>
                        <template v-if="typeof tableOptions.row_total_field !== undefined && tableOptions.row_total_field.length ? tableOptions.row_total_field.filter((e) => e === item.name) : false">{{ allTotal[item.name] }}</template>
                        <template v-else ></template>
                    </template>
                </Column>
            </Row>
        </ColumnGroup> -->

    </DataTable>
</template>


<script>
    import { onMounted, ref, watchEffect } from "vue";

    import { useStore } from "@/system_modules/store";
    import moment from "moment-timezone";

    // import { FilterOperator, FilterMatchMode, FilterService } from "primevue/api";
    import { FilterMatchMode, FilterOperator, FilterService } from '@primevue/core/api';

    import { G } from "@/_common";

    // import Dialog from "primevue/dialog";
    // import FileUpload from "primevue/fileupload";
    // import Toolbar from "primevue/toolbar";
    // import Rating from "primevue/rating";
    // import RadioButton from "primevue/radiobutton";
    // import Textarea from "primevue/textarea";
    import MultiSelect from "primevue/multiselect";
    import Button from "primevue/button";
    import InputMask from "primevue/inputmask";
    import InputText from "primevue/inputtext";
    import InputNumber from "primevue/inputnumber";
    import DatePicker from "primevue/datepicker";
    import Column from "primevue/column";
    import DataTable from "primevue/datatable";
    // import Dropdown from "primevue/dropdown";
    import Select from "primevue/select";
    import Row from "primevue/row";
    import ColumnGroup from "primevue/columngroup";
    // import ColorPicker from 'primevue/colorpicker';

    import InputClear from '@/components/field/InputClear';

    export default {
        name: 'DADataTable',
        props: {
            tableData: {
                type: Object,
                default: () => []
            },
            tableOptions: {
                type: Object,
                default: () => {}
            },
        },
        components: {
            // Dialog,
            // FileUpload,
            // Toolbar,
            // Rating,
            // RadioButton,
            MultiSelect,
            // Textarea,
            Button,
            InputMask,
            InputText,
            InputNumber,
            Column,
            DataTable,
            // Dropdown,
            Select,
            Row,
            ColumnGroup,
            DatePicker,
            // ColorPicker,

            InputClear,
        },
        setup(props) {
            const store = useStore();

            const dt = ref({});
            const editingRows = ref();
            const selectedProducts = ref();
            const filters = ref({});
            const mainFilter = ref({});

            const currentPageItems = ref([]);
            const pageTotal = ref({});
            const allTotal = ref({});
            const filteredTotal = ref({});
            const filteredValues = ref([]);

            const rowsPerPage = props.tableOptions.rows || G.rowsPerPage;
            const rowsPerPageOptions = props.tableOptions.rowPerPageOptions || G.rowsPerPageOptions;

            const TR = ref({});

            const selectedColumns = ref();
            const table_columns = ref();
            const onToggle = (val) => {
                selectedColumns.value = props.tableOptions.data_table_columns.filter(col => val.includes(col.name));
            };

            onMounted(() => {
                initFilter();
            });

            FilterService.register("customFilter", (value, fl) => {
                if (fl === undefined || fl === null) {
                    return true;
                }
                if (value === undefined || value === null) {
                    return false;
                }
                return value.toString() === fl.value.toString();
            });

            watchEffect(() => {
                TR.value = store.getTranslation();

                props.tableOptions.globalFilterFields = props.tableOptions.data_table_columns
                    .reduce(
                        (acc, cur) => cur.name == "create_date" || cur.name == "update_date" ? acc : [...acc, cur.name],
                        []
                    );

                selectedColumns.value = props.tableOptions.data_table_columns.filter(e => e.visible == undefined || e.visible == true).map(e => e.name);
                table_columns.value = props.tableOptions.data_table_columns.map(e => { return {"value": e.name, "label": e.title}; });

                if( props.tableData && !props.tableData.length && props.tableOptions.row_total_field ){
                    currentPageItems.value = [];
                    calculateTotal();
                }

                if( props.tableData.length ){
                    ['create_date', 'update_date'].forEach(df => {
                        props.tableData.forEach(x => {
                            x[df] = (x[df] && x[df] != null && x[df] != '') ? new Date(G.dateToStr(x[df], 'pg_datetime')) : null;
                            //moment.utc(( x[df].split("+")[1].length > 5 ? x[df].slice(0, -3) : x[df] )).tz(G.systemData.timezone?.value).format(G.datetime_format['datetime']) : null;
                        });
                    });

                    if( props.tableOptions && props.tableOptions.date_columns !== undefined ){
                        let dtc = props.tableOptions.date_columns;
                        Object.keys(dtc).forEach(df => {
                            props.tableData.forEach(x => {
                                x[df] = (x[df] && x[df] != null && x[df] != '') ? new Date(G.dateToStr(x[df], 'pg_datetime')) : null;
                                // moment.utc(( x[df].split("+")[1].length > 5 ? x[df].slice(0, -3) : x[df] )).tz(G.systemData.timezone?.value).format(G.datetime_format[dtc[df]]) : null;
                            });
                        });
                    }
                }
            });

            // setTimeout(() => {
            // }, 1000);

            const clearFilter = () => {
                dt.value.d_first = 0;
                filters.value = mainFilter.value;
            };
            const resetFilter = (field) => {
                filters.value[field] = mainFilter.value[field];
            };
            const initFilter = () => {
                mainFilter.value = {
                    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
                };
                if( props.tableOptions && props.tableOptions.data_table_columns )
                {
                    props.tableOptions.data_table_columns.forEach((e) => {
                        if (e.filters !== undefined){
                            mainFilter.value[e.filter_field ? e.filter_field : e.name] = e.filters;
                        }
                        else if (e.filter === undefined || e.filter) {
                            mainFilter.value[e.filter_field ? e.filter_field : e.name] = {
                                operator: FilterOperator.OR,
                                // operator: 'OR',
                                constraints: [
                                    {
                                        value: null,
                                        matchMode: FilterMatchMode.STARTS_WITH
                                    }
                                ]
                            };
                        }
                    });
                }
                filters.value = mainFilter.value;
            };

            const exportCSV = () => {
                dt.value.exportCSV();
            };

            const expF = (obj) => {
                let {data, field} = obj;
                let dtc = props.tableOptions?.date_columns || {};
                return ( Object.keys(dtc).filter(a => dtc[a] == 'datetime' &&  a == field).length > 0 )
                    ? G.dateToStr(data, 'datetime')
                    : (
                        ( Object.keys(dtc).filter(a => dtc[a] == 'date' &&  a == field).length > 0 )
                        ? G.dateToStr(data, 'date')
                        : ( ( Object.keys(dtc).filter(a => dtc[a] == 'time' &&  a == field).length > 0 )
                            ? G.dateToStr(data, 'time')
                            : String(data)
                          )
                      )
                    ;
            };

            const pageTotal1 = (field) => {
                let total = 0;
                if (currentPageItems.value.length) {
                    for (let p of currentPageItems.value) {
                        total += p[field] || 0;

                    }
                }
                pageTotal.value[field] = G.formatLocale(total);
            };
            const allTotal1 = (field) => {
                let total = 0;
                for (let p of props.tableData) {
                    total += p[field] || 0;
                }
                allTotal.value[field] = G.formatLocale(total);
            };
            const filteredTotal1 = (field) => {
                let total = 0;
                for (let p of filteredValues.value) {
                    total += p[field] || 0;
                }
                filteredTotal.value[field] = G.formatLocale(total);
            };
            const onChangeValue = (e) => {
                if (props.tableOptions.row_total && Array.isArray(e) && dt.value) {
                    currentPageItems.value = e.slice(
                        dt.value.d_first,
                        dt.value.d_first + dt.value.d_rows
                    );
                    setTimeout(() => {
                        calculateTotal();
                    }, 300);
                }
            };

            const onFiltered = (e) => {
                if( props.tableOptions.row_total && props.tableData.length > rowsPerPage ){
                    filteredValues.value = e.filteredValue;
                }
            };

            const calculateTotal = () => {
                if( props.tableOptions.row_total_field )
                {
                    props.tableOptions.row_total_field.forEach((field) => {
                        pageTotal1(field);
                        allTotal1(field);
                        if( props.tableOptions.row_total && props.tableData.length > rowsPerPage )
                            filteredTotal1(field);
                    });
                }
            };

            const tableRowClass = (data) => {
                // let rc = data.status === 0 ? 'bg-danger text-light': (data.status === 2 ? 'bg-warning text-light': data.status < 0 ? 'bg-secondary text-light' : '');
                // rc += ((props.tableOptions.row_class !== undefined && typeof props.tableOptions.row_class === 'function') ? props.tableOptions.row_class(data) : (props.tableOptions.row_class !== undefined ? ` ${props.tableOptions.row_class}` : ''));

                let rc = [];
                rc.push(data.status == 0 || data.status == false ? 'bg-danger bg-opacity-25 text-secondary text-opacity-50': (data.status == 2 ? 'bg-warning text-light': data.status < 0 ? 'bg-secondary text-light' : ''));
                rc.push(((props.tableOptions.row_class !== undefined && typeof props.tableOptions.row_class === 'function') ? props.tableOptions.row_class(data) : (props.tableOptions.row_class !== undefined ? ` ${props.tableOptions.row_class}` : '')))
                return rc.join(' ');
            };

            return {
                G,
                TR,
                store,
                moment,
                dt,
                editingRows,
                rowsPerPage,
                rowsPerPageOptions,
                selectedProducts,
                filters,
                exportCSV,
                expF,

                clearFilter,
                resetFilter,
                onChangeValue,
                onFiltered,
                pageTotal,
                allTotal,
                filteredTotal,
                tableRowClass,

                selectedColumns,
                onToggle,
                table_columns,
            };
        },
    };
</script>


<style lang="scss">
.dt-main{
    .form-check{
        min-height: 0px;
    }
    .btnicon button{
        width: 38px;
        height: 38px;
        text-align: center;
    }
    .btnicon i{
        width: 16px;
        height: 16px;
    }
    .p-multiselect-label.p-multiselect-label-empty, .p-multiselect-label{
        display: none;
    }
    .p-multiselect-header{
        background-color: rgba(var(--bs-secondary-rgb), .1);
        align-items: center;
        padding: 10px 15px;
    }
    .p-datatable-popover-filter {
        margin-inline-start: unset;
    }
    .p-datatable-column-title{
        padding-right: .5rem;
    }
    th, td{
        border: 1px solid rgba(225, 225, 225, 0.4) !important;
    }
    .p-datatable-column-header-content {
        display: inline-flex;
    }
    .form-check .form-check-input {
        float: unset;
    }
    table{
        border-collapse: unset;
    }
}
</style>
